<script lang="ts">
	import { shoppingCart } from '$lib/state/shoppingCart.svelte';
	import type { GlobalCartData } from '$lib/storyblok/types';
	import type { ISbStoryData } from '@storyblok/js';
	import { onMount } from 'svelte';

	interface Props {
		content: ISbStoryData<GlobalCartData>['content'];
	}

	let { content }: Props = $props();

	onMount(() => {
		shoppingCart.merge(content);
	});
</script>
